import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import GeoContext from 'contexts/geoContext'
import React, { useContext, useMemo } from 'react'
import { useTrip } from 'tripPlanner/hooks/api'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from 'tripPlanner/utils'
import { findNearestItem, formatDistance } from 'tripPlanner/utils/geo'

interface Props {
  item: TripItem
}

function DistanceToAccommodation({ item }: Props) {
  const { data: trip } = useTrip({ tripId: item.tripId })
  const { currentRegionCode } = useContext(GeoContext)

  const place = getItemPlace(item, 'start')

  const nearestAccommodation = useMemo(() => {
    if (!trip || !place || place.type !== 'GEO') {
      return
    }

    return findNearestItem(trip.items.filter(i => i.type === 'ACCOMMODATION'), place.point.lat, place.point.lng)
  }, [place, trip])

  if (!nearestAccommodation || nearestAccommodation.distance > 100) {
    return null
  }

  const formattedDistance = formatDistance(nearestAccommodation.distance, currentRegionCode)

  return (
    <BodyTextBlock variant="medium" weight="bold" colour="highlight-secondary" startIcon={<LineMapMarkerIcon />}>
      {formattedDistance} from {nearestAccommodation.item.place.name}
    </BodyTextBlock>
  )
}

export default DistanceToAccommodation
